import { useTranslation } from 'react-i18next'

import { toastFactory } from '@/factories'
import { downloadHref } from '@/utils'

import * as S from './vendor-details-modal.styled'

type COILinkProps = {
  filePath?: string
  visitorName: string
}

export const COILink = ({ filePath, visitorName }: COILinkProps) => {
  const { t } = useTranslation(['visitors'])
  if (!filePath) return <span>---</span>

  const fileName = `${visitorName}_COI.pdf`
  const link = `${import.meta.env.VITE_ASSETS_URL}/vendor-coi/${filePath.split('/').pop()}`

  const handleDownload = async () => {
    try {
      await downloadHref(link, fileName)
    } catch {
      toastFactory.error(t('visitors:dashboard.snackbar.coiDownloadError'))
    }
  }

  return <S.COILinkButton onClick={handleDownload}>{fileName}</S.COILinkButton>
}
